import { RES, langTxt, chTxt } from "./logic";

// 시안 resTag·langTag·chTag
export const ResTag = ({ result }) => {
    const [cls, label] = RES[result] || ["gen", result || "-"];
    return <span className={`tag tag-${cls}`}>{label}</span>;
};
export const LangTag = ({ lang }) => <span className={`tag ${lang === "zh" ? "tag-zh" : "tag-gen"}`}>{langTxt(lang)}</span>;
export const ChTag = ({ channel }) => <span className={`tag ${channel === "web" ? "tag-web" : "tag-mob"}`}>{chTxt(channel)}</span>;
